export const colors = {
    black: '#000000',
    white: '#FFFFFF',
    red: '#C90015',
    inputRed: '#CE2C3D',
    inputBlack: '#383636',
}
